module.exports = __webpack_public_path__ + "static/media/tda3000.6b215c59.pdf";